import React from 'react';

const Loader = () => {
  return (
    <div className='loader-container '>
      <div className='loader'>
        <div className='loader-text'>F</div>
        <div className='loader-text'>T</div>
        <div className='loader-text'>G</div>
      </div>
    </div>
  );
};

export default Loader;
